<div class="new-item-planner" id="fb-forecast">
  <div class="container-fluid item-wrapper">
    <form class="account-form">
      <div class="row">
        <div class="col-12">
          <h2>New Item Forecast Setting</h2>
        </div>
        <div class="col-md-6 padding-right">
          <div>
            <div class="form-group">
              <label for="launchCurve">Launch Curve</label>
              <mat-select
                [disabled]="!editPermission"
                [(ngModel)]="dataModel.launchCurveId"
                name="launchCurve"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option
                  *ngFor="let item of launchCurvesList"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </div>
            <div class="form-group">
              <label for="launchCurve">Seasonlaity Index</label>
              <mat-select
                [(ngModel)]="dataModel.seasonalityIndexId"
                [disabled]="!editPermission"
                name="seasonlaityIndex"
                [ngModelOptions]="{ standalone: true }"
                (selectionChange)="createItemAccountLists()"
              >
                <mat-option
                  *ngFor="let item of seasonlaityIndexList"
                  [value]="item.commonCodeValueId"
                >
                  {{ item.value }}
                </mat-option>
              </mat-select>
            </div>
            <div class="form-group">
              <label for="launchCurve">Seasonlaity Pattern Product</label>
              <mat-select
                [disabled]="!editPermission"
                [(ngModel)]="dataModel.seasonalityPatternProductId"
                name="seasonlaityPatternProduct"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option
                  *ngFor="let item of seasonlaityPatternProductList"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </div>
            <div class="form-group">
              <label for="launchCurve">Seasonlaity Pattern Account</label>
              <mat-select
                [disabled]="!editPermission"
                [(ngModel)]="dataModel.seasonalityPatternAccountId"
                name="seasonlaityPatternAccount"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option
                  *ngFor="let item of seasonlaityPatternAccountList"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="bottom-div">
            <div class="form-group">
              <label for="">Active</label>
              <mat-slide-toggle
                [disabled]="!editPermission"
                [(ngModel)]="dataModel.nipActive"
              ></mat-slide-toggle>
            </div>
            <div class="form-group">
              <div class="action-panel text-right btn-wrapper">
                <button
                  (click)="apply()"
                  mat-raised-button
                  class="btn btn-primary m-left"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 padding-left">
          <div>
            <div class="form-group">
              <label for="baseLineRunRate">BaseLine Run Rate</label>
              <input [(ngModel)]="dataModel.baselineRunRate" type="number" />
            </div>
            <div class="form-group">
              <label for="launchCurve">Brand</label>
              <mat-select
                [disabled]="!editPermission"
                [(ngModel)]="dataModel.brandId"
                [class.loading-div]="brandLoading"
                (selectionChange)="GetProductGroupList(dataModel.brandId)"
                name="brand"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option
                  *ngFor="let item of brandList"
                  [value]="item.brandId"
                >
                  {{ item.brandName }}
                </mat-option>
              </mat-select>
            </div>
            <div class="form-group">
              <label for="productGroup">Product Group</label>
              <mat-select
                [disabled]="!editPermission"
                [(ngModel)]="dataModel.productGroupId"
                [class.loading-div]="productGroupLoading"
                (selectionChange)="
                  GetProductFamilyList(dataModel.productGroupId)
                "
                name="productGroup"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option
                  *ngFor="let item of productGroupList"
                  [value]="item.productGroupId"
                >
                  {{ item.productGroupName }}
                </mat-option>
              </mat-select>
            </div>
            <div class="form-group">
              <label for="productFamily">Product Family</label>
              <mat-select
                [disabled]="!editPermission"
                [(ngModel)]="dataModel.productFamilyId"
                [class.loading-div]="productFamilyLoading"
                name="productFamily"
                [ngModelOptions]="{ standalone: true }"
                (selectionChange)="
                  GetParentProductList(dataModel.productFamilyId, true)
                "
              >
                <mat-option
                  *ngFor="let item of productFamilyList"
                  [value]="item.productFamilyId"
                >
                  {{ item.productFamilyName }}
                </mat-option>
              </mat-select>
            </div>
            <div class="form-group">
              <label for="parentProduct">Parent Product</label>
              <mat-select
                [disabled]="!editPermission"
                [(ngModel)]="dataModel.parentProductId"
                [class.loading-div]="parentProductLoading"
                name="parentProduct"
                [ngModelOptions]="{ standalone: true }"
                (selectionChange)="GetItemList()"
              >
                <mat-option
                  *ngFor="let item of parentProductList"
                  [value]="item.parentProductId"
                >
                  {{ item.parentProductName }}
                </mat-option>
              </mat-select>
            </div>
            <div class="form-group">
              <label for="parentProduct">Item</label>
              <mat-select
                [disabled]="!editPermission"
                [(ngModel)]="dataModel.oldItemId"
                name="items"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option
                  *ngFor="let item of selectedItemsList"
                  [value]="item.itemManagerId"
                  >{{ item.description }}
                </mat-option>
              </mat-select>
            </div>
            <div class="form-group time-dropdown">
              <label for="timeFrame">Time Frame</label>
              <app-treeview-dropdown
                [disabled]="!editPermission"
                [type]="'Timeframe'"
                [items]="calendarListDropdown"
                (valueChange)="setValue($event)"
              >
              </app-treeview-dropdown>
            </div>
          </div>
          <div class="bottom-div">
            <div class="form-group">
              <div class="action-panel text-right btn-wrapper">
                <button
                  (click)="getCalculation()"
                  mat-raised-button
                  class="btn btn-primary m-left"
                >
                  Claculate and Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="items-wrapper-grid new-item-account-setting-grid">
    <ag-grid-angular
      class="ag-theme-material"
      [gridOptions]="gridOptions"
      [defaultColDef]="defaultColDef"
      [headerHeight]="headerHeight"
      [columnDefs]="columnDefs"
      [rowData]="accountSettingList"
      (gridReady)="onGridReady($event)"
      [modules]="modules"
      [rowSelection]="rowSelection"
      [suppressRowClickSelection]="true"
      (selectionChanged)="onSelectionChanged($event)"
      #grid2
    >
    </ag-grid-angular>
  </div>
  <div class="col-12 btn-wrapper">
    <button class="btn btn-secondary">Close</button>
    <button class="btn btn-primary" (click)="saveSettings()">Save</button>
  </div>
</div>
